// @mui/icons-material
// The MIT License (MIT)
// Copyright (c) 2014 Call-Em-All
// see https://github.com/mui/material-ui/blob/master/LICENSE

import { SVGAttributes, defineComponent } from "vue"

function defineIcon(name: string, d: string) {
  return defineComponent<SVGAttributes>({
    name,
    setup() {
      return () =>
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d={d}></path>
        </svg>
    },
  })
}

export const CheckboxCheckedIcon = defineIcon(
  "CheckboxCheckedIcon",
  "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
)

export const CheckboxBlankIcon = defineIcon(
  "CheckboxBlankIcon",
  "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
)

export const CheckboxIndeterminateIcon = defineIcon(
  "CheckboxIndeterminateIcon",
  "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
)
